export const TERMS_DEFINITIONS = [
  {
    term: 'Cookie',
    description:
      'small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference or login information.',
  },
  {
    term: 'Company',
    description:
      'when this policy mentions “Company,” “we,” “us,” or “our,” it refers to QRBrain.io, which is responsible for your information under these Terms & Conditions.',
  },
  {
    term: 'Country',
    description: 'where QRBrain.io or the owners/founders of QRBrain.io are based, in this case is AR',
  },
  {
    term: 'Device',
    description:
      'any internet connected device such as a phone, tablet, computer or any other device that can be used to visit QRBrain.io and use the services.',
  },
  {
    term: 'Service',
    description:
      'refers to the service provided by QRBrain.io as described in the relative terms (if available) and on this platform.',
  },
  {
    term: 'Third-party service',
    description:
      'refers to advertisers, contest sponsors, promotional and marketing partners, and others who provide our content or whose products or services we think may interest you.',
  },
  {
    term: 'Website',
    description: "QRBrain.io's site, which can be accessed via this URL: https://qrbrain.io",
  },
  {
    term: 'You',
    description: 'a person or entity that is registered with QRBrain.io to use the Services.',
  },
];

export const TERMS_RESTRICTIONS = [
  'License, sell, rent, lease, assign, distribute, transmit, host, outsource, disclose or otherwise commercially exploit the website or make the platform available to any third party.',
  'Modify, make derivative works of, disassemble, decrypt, reverse compile or reverse engineer any part of the website.',
  'Remove, alter or obscure any proprietary notice (including any notice of copyright or trademark) of QRBrain.io or its affiliates, partners, suppliers or the licensors of the website.',
];
